import React from 'react';
import { useSelector } from 'react-redux';

import classNames from 'classnames';

import { getModalInformation } from 'features/order-tracker/store/selectors';

import { CommonModal } from '../CommonModal';
import { AmendAppointmentModal, LoadingModal, OrderDetailsModal, PONRModal } from './components';
import { ModalTypes } from './constants';

import styles from './styles.module.scss';

export const ModalComponent: React.FC = () => {
  const { isOpened, modalType, data } = useSelector(getModalInformation);
  let hasCloseBtn = true;
  let modalContent;
  let additionalClassName;

  switch (modalType) {
    case ModalTypes.AmendAppointment:
      modalContent = <AmendAppointmentModal />;
      additionalClassName = styles.amendAppointmentModal;
      hasCloseBtn = false;
      break;
    case ModalTypes.PONRModal:
      modalContent = <PONRModal />;
      additionalClassName = styles.ponrAppointmentModal;
      break;
    case ModalTypes.OrderDetails:
      modalContent = <OrderDetailsModal orderReference={data.orderReference!} />;
      break;
    case ModalTypes.Loading:
    case ModalTypes.LoadingWhileAmending:
      modalContent = <LoadingModal isAfterAmending={modalType === ModalTypes.LoadingWhileAmending} />;
      additionalClassName = styles.loadingModal;
      hasCloseBtn = false;
      break;
    default:
      modalContent = '';
  }

  return (
    <CommonModal
      className={classNames({
        [additionalClassName]: !!additionalClassName,
      })}
      isOpened={isOpened}
      parentSelector="body"
      hasCloseBtn={hasCloseBtn}
    >
      {modalContent}
    </CommonModal>
  );
};
